/**
 * Sale email capture popup
 * - Subscribes to Shopify newsletter (same as footer customer form)
 * - Sends staff notification via Shopify contact form
 * - localStorage: close count (max 2), permanent hide after subscribe
 */
(function () {
  'use strict';

  var STORAGE_SUBSCRIBED = 'sale_popup_subscribed';
  var STORAGE_CLOSE_COUNT = 'sale_popup_close_count';
  var SUPPRESSED_PREFIXES = ['/cart', '/checkout', '/account', '/challenge', '/password'];

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function parseConfig() {
    var el = document.getElementById('sale-email-popup-config');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function isSuppressedPath() {
    var path = window.location.pathname || '';
    for (var i = 0; i < SUPPRESSED_PREFIXES.length; i++) {
      if (path.indexOf(SUPPRESSED_PREFIXES[i]) === 0) return true;
    }
    return false;
  }

  function shouldShow(config) {
    if (!config || !config.enabled) return false;
    if (window.Shopify && window.Shopify.designMode) return false;
    if (isSuppressedPath()) return false;

    try {
      if (localStorage.getItem(STORAGE_SUBSCRIBED) === '1') return false;
      var closes = parseInt(localStorage.getItem(STORAGE_CLOSE_COUNT) || '0', 10);
      if (closes >= (config.maxCloses || 2)) return false;
    } catch (e) {
      return true;
    }
    return true;
  }

  function recordClose(config) {
    try {
      var closes = parseInt(localStorage.getItem(STORAGE_CLOSE_COUNT) || '0', 10) + 1;
      localStorage.setItem(STORAGE_CLOSE_COUNT, String(closes));
      if (closes >= (config.maxCloses || 2)) {
        localStorage.setItem(STORAGE_SUBSCRIBED, '1');
      }
    } catch (e) { /* ignore */ }
  }

  function recordSubscribed() {
    try {
      localStorage.setItem(STORAGE_SUBSCRIBED, '1');
      localStorage.setItem(STORAGE_CLOSE_COUNT, '99');
    } catch (e) { /* ignore */ }
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  function postForm(body) {
    return fetch('/contact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        Accept: 'text/html, application/xhtml+xml',
      },
      credentials: 'same-origin',
      body: body.toString(),
    });
  }

  function responseLooksSuccessful(html) {
    if (!html) return false;
    if (/newsletter-success|form-posted-success|thank you for subscribing|successfully subscribed/i.test(html)) {
      return true;
    }
    if (/already subscribed|already exists|is already associated|duplicate/i.test(html)) {
      return true;
    }
    return (
      /form-success|thank you|subscribed successfully/i.test(html) &&
      !/invalid email|errors found|could not/i.test(html)
    );
  }

  function subscribeNewsletter(email, config) {
    var tags = (config.newsletterTags || 'newsletter, prospect, sale-popup') + ', ' + (config.saleId || 'sale');
    var body = new URLSearchParams();
    body.append('form_type', 'customer');
    body.append('utf8', '\u2713');
    body.append('contact[email]', email);
    body.append('contact[tags]', tags);
    return postForm(body).then(function (res) {
      return res.text().then(function (html) {
        return { ok: res.ok && responseLooksSuccessful(html), html: html };
      });
    });
  }

  function notifyTeam(email, config) {
    var notifyList = config.notifyEmails || 'sales@thesaunasolutionll.com, alaintmislang@gmail.com';
    var body = new URLSearchParams();
    body.append('form_type', 'contact');
    body.append('utf8', '\u2713');
    body.append('contact[name]', 'Sale Popup — ' + (config.saleTitle || 'Offer'));
    body.append('contact[email]', email);
    body.append(
      'contact[body]',
      [
        'New sale popup email signup on ' + (config.shopName || 'store'),
        '',
        'Subscriber email: ' + email,
        'Active sale: ' + (config.saleTitle || 'n/a') + ' (' + (config.saleId || '') + ')',
        'Page: ' + window.location.href,
        'Time: ' + new Date().toISOString(),
        '',
        'Notify also: ' + notifyList,
      ].join('\n')
    );

    return postForm(body).catch(function () {
      return { ok: false };
    });
  }

  ready(function () {
    var popup = document.getElementById('sale-email-popup');
    var config = parseConfig();
    if (!popup || !config) return;
    if (!shouldShow(config)) return;

    var backdrop = popup.querySelector('.sale-email-popup__backdrop');
    var closeBtns = popup.querySelectorAll('[data-sale-popup-close]');
    var form = popup.querySelector('[data-sale-popup-form]');
    var input = popup.querySelector('#sale-email-popup-input');
    var submitBtn = popup.querySelector('[data-sale-popup-submit]');
    var submitText = popup.querySelector('[data-sale-popup-submit-text]');
    var errorEl = popup.querySelector('[data-sale-popup-error]');
    var successEl = popup.querySelector('[data-sale-popup-success]');
    var successPanel = popup.querySelector('[data-sale-popup-success-panel]');
    var confettiCanvas = popup.querySelector('[data-sale-popup-confetti]');
    var dialogEl = popup.querySelector('.sale-email-popup__dialog');
    var hookTextEl = popup.querySelector('[data-sale-popup-hook-text]');
    var showTimer = null;
    var hideTimer = null;
    var hookTimer = null;
    var countdownTimer = null;
    var countdownEl = popup.querySelector('[data-sale-popup-countdown]');
    var countdownDays = popup.querySelector('[data-sale-countdown-days]');
    var countdownHours = popup.querySelector('[data-sale-countdown-hours]');
    var countdownMins = popup.querySelector('[data-sale-countdown-mins]');
    var countdownSecs = popup.querySelector('[data-sale-countdown-secs]');
    var hookIndex = 0;
    var hooks = getHooksForSale(config.saleId);
    var buttonCTAs = getButtonCTAsForSale(config.saleId);
    var defaultSubmitLabel = buttonCTAs[0] || 'Grab My Exclusive Offers';

    function getHooksForSale(saleId) {
      var bank = window.SalePopupHooks || {};
      if (saleId && Array.isArray(bank[saleId]) && bank[saleId].length) {
        return bank[saleId];
      }
      return bank.evergreen || [];
    }

    function getButtonCTAsForSale(saleId) {
      var bank = window.SalePopupButtonCTAs || {};
      if (saleId && Array.isArray(bank[saleId]) && bank[saleId].length) {
        return bank[saleId];
      }
      return bank._default || ['Grab My Exclusive Offers'];
    }

    function setButtonLabel(text, animateIn) {
      if (!submitText || !text) return;
      if (!animateIn) {
        submitText.textContent = text;
        submitText.classList.remove('is-out', 'is-in');
        return;
      }
      submitText.classList.remove('is-in');
      submitText.classList.add('is-out');
      setTimeout(function () {
        submitText.textContent = text;
        submitText.classList.remove('is-out');
        submitText.classList.add('is-in');
      }, 380);
    }

    function setHookText(text, animateIn) {
      if (!hookTextEl || !text) return;
      hookTextEl.textContent = text;
      hookTextEl.classList.remove('is-out');
      if (animateIn) {
        hookTextEl.classList.remove('is-in');
        requestAnimationFrame(function () {
          hookTextEl.classList.add('is-in');
        });
      }
    }

    function rotateHook() {
      var idx = hookIndex;
      if (hookTextEl && hooks.length) {
        hookTextEl.classList.remove('is-in');
        hookTextEl.classList.add('is-out');
        setTimeout(function () {
          setHookText(hooks[idx], true);
        }, 420);
      }
      if (buttonCTAs.length) {
        setButtonLabel(buttonCTAs[idx % buttonCTAs.length], true);
      }
      hookIndex = (hookIndex + 1) % Math.max(hooks.length, buttonCTAs.length, 1);
    }

    function startHookRotation() {
      stopHookRotation();
      if (!hooks.length && !buttonCTAs.length) {
        if (hookTextEl) hookTextEl.hidden = true;
        return;
      }
      if (hookTextEl) hookTextEl.hidden = false;
      hookIndex = 0;
      if (hooks.length) setHookText(hooks[0], true);
      if (buttonCTAs.length) setButtonLabel(buttonCTAs[0], false);
      hookIndex = 1;
      var interval = parseInt(config.hookIntervalMs, 10);
      if (isNaN(interval) || interval < 3000) interval = 10000;
      hookTimer = setInterval(rotateHook, interval);
    }

    function stopHookRotation() {
      if (hookTimer) {
        clearInterval(hookTimer);
        hookTimer = null;
      }
    }

    function pad2(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function updateCountdown() {
      if (!countdownEl) return;
      var endStr = config.saleEnd || countdownEl.getAttribute('data-sale-end');
      if (!endStr) return;
      var end = new Date(endStr + 'T23:59:59');
      var now = new Date();
      var diff = end.getTime() - now.getTime();
      if (diff <= 0) {
        if (countdownDays) countdownDays.textContent = '00';
        if (countdownHours) countdownHours.textContent = '00';
        if (countdownMins) countdownMins.textContent = '00';
        if (countdownSecs) countdownSecs.textContent = '00';
        return;
      }
      var secs = Math.floor(diff / 1000);
      var days = Math.floor(secs / 86400);
      secs -= days * 86400;
      var hours = Math.floor(secs / 3600);
      secs -= hours * 3600;
      var mins = Math.floor(secs / 60);
      secs -= mins * 60;
      if (countdownDays) countdownDays.textContent = pad2(days);
      if (countdownHours) countdownHours.textContent = pad2(hours);
      if (countdownMins) countdownMins.textContent = pad2(mins);
      if (countdownSecs) countdownSecs.textContent = pad2(secs);
    }

    function startCountdown() {
      stopCountdown();
      if (!countdownEl) return;
      updateCountdown();
      countdownTimer = setInterval(updateCountdown, 1000);
    }

    function stopCountdown() {
      if (countdownTimer) {
        clearInterval(countdownTimer);
        countdownTimer = null;
      }
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg;
      errorEl.hidden = false;
    }

    function clearError() {
      if (!errorEl) return;
      errorEl.textContent = '';
      errorEl.hidden = true;
    }

    function openPopup() {
      popup.removeAttribute('hidden');
      startHookRotation();
      startCountdown();
      requestAnimationFrame(function () {
        popup.classList.add('is-visible');
      });
      document.body.style.overflow = 'hidden';
    }

    function closePopup(permanent) {
      stopHookRotation();
      stopCountdown();
      popup.classList.remove('is-visible', 'is-success', 'is-celebrating');
      if (successPanel) successPanel.hidden = true;
      document.body.style.overflow = '';
      hideTimer = setTimeout(function () {
        popup.setAttribute('hidden', '');
      }, 320);
      if (!permanent) recordClose(config);
    }

    function showSuccess() {
      recordSubscribed();
      stopHookRotation();
      popup.classList.add('is-success', 'is-celebrating');
      if (successPanel) successPanel.hidden = false;

      if (window.SalePopupConfetti && confettiCanvas && dialogEl) {
        var rect = dialogEl.getBoundingClientRect();
        window.SalePopupConfetti.launch(confettiCanvas, {
          x: rect.left + rect.width * 0.5,
          y: rect.top + rect.height * 0.42,
        });
      }

      hideTimer = setTimeout(function () {
        closePopup(true);
      }, 4500);
    }

    closeBtns.forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        closePopup(false);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('is-visible')) {
        closePopup(false);
      }
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearError();

        var email = (input && input.value ? input.value : '').trim().toLowerCase();
        if (!isValidEmail(email)) {
          showError('Please enter a valid email address.');
          return;
        }

        if (submitBtn) submitBtn.disabled = true;
        if (submitText) submitText.textContent = 'Locking In Your Offer…';

        Promise.all([
          subscribeNewsletter(email, config),
          notifyTeam(email, config),
        ])
          .then(function (results) {
            var newsletterResult = results[0];
            if (newsletterResult && newsletterResult.ok) {
              showSuccess();
              return;
            }
            showError('Something went wrong. Please call us or try again.');
          })
          .catch(function () {
            showError('Connection error. Please try again or call us directly.');
          })
          .finally(function () {
            if (submitBtn) submitBtn.disabled = false;
            if (submitText) setButtonLabel(defaultSubmitLabel, false);
          });
      });
    }

    var delay = parseInt(config.delayMs, 10);
    if (isNaN(delay) || delay < 0) delay = 2000;

    showTimer = setTimeout(openPopup, delay);
  });
})();
